module.exports = __webpack_public_path__ + "img/lg_ring_g_c_0_1@2x.2004af80.png";